import { Container, Text } from '@/components/ui/index.js'
import styles from './LandingFooter.module.css'

export function LandingFooter() {
  return (
    <footer className={styles.footer}>
      <Container size="lg">
        <div className={styles.inner}>
          <Text variant="body-sm" color="inverse">
            © 2026 Cuggu. All rights reserved.
          </Text>
          <div className={styles.links}>
            <a href="/terms" className={styles.link}>이용약관</a>
            <a href="/privacy" className={styles.link}>개인정보처리방침</a>
          </div>
        </div>
      </Container>
    </footer>
  )
}
